<template>
  <div>TrangXemDonVi</div>
</template>

<script>
export default {
  name: "TrangXemDonVi"
};
</script>


